import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "player-speed"
}

import { computed, onMounted, ref } from 'vue'
import { RateControl, AudioDoc } from '@/services/player'
import { assertNotNull } from '@/helpers/typing'


export default /*@__PURE__*/_defineComponent({
  __name: 'Rate',
  props: {
    audio: {}
  },
  setup(__props: any) {

const props = __props

const rateControl = ref<RateControl | null>(null)

onMounted(() => {
  rateControl.value = new RateControl(props.audio)
})

function formatRate(rate: number): string {
  const result = (Math.round(rate * 10) / 10).toLocaleString(undefined, {
    minimumFractionDigits: 1,
  })
  return `${result}x`
}

/**
 * Expose playback rate as reactive property.
 *
 * If we just use `rateControl.rate()` inside the view (event if it is made property),
 * it doesn't work and changes are not reflected in the view.
 */
const playbackRate = computed(() => {
  return assertNotNull(rateControl.value).rate()
})

return (_ctx: any,_cache: any) => {
  return (rateControl.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("button", {
          class: "player-speed__btn player-speed__btn--up",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (rateControl.value.up()))
        }, [...(_cache[3] || (_cache[3] = [
          _createElementVNode("span", { class: "iconfont iplayer-fast" }, null, -1)
        ]))]),
        _createElementVNode("span", {
          class: "player-speed__text",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (rateControl.value.reset()))
        }, _toDisplayString(formatRate(playbackRate.value)), 1),
        _createElementVNode("button", {
          class: "player-speed__btn player-speed__btn--down",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (rateControl.value.down()))
        }, [...(_cache[4] || (_cache[4] = [
          _createElementVNode("span", { class: "iconfont iplayer-slow" }, null, -1)
        ]))])
      ]))
    : _createCommentVNode("", true)
}
}

})